import { render, staticRenderFns } from "./QuickReportSupervisor.vue?vue&type=template&id=c033c364&"
import script from "./QuickReportSupervisor.vue?vue&type=script&lang=js&"
export * from "./QuickReportSupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports